import React, { useState, useEffect } from "react";
import "../../../Styles/Modal.css";
import "../../../Styles/reModal.css";
import { ImCancelCircle } from "react-icons/im";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import ReLoginModal from "../../ReLoginModal";
import { CircularProgress } from "@mui/material";

type Customer = {
  businessName: string;
  _id: string;
  customerAccount: any;
  customer: string;
  state: string;
  country: string;
};

const CustomerModal = ({ handleCusSelect, selCus, handleCusModal }: any) => {
  const [getCustomer, setGetCustomer] = useState<Customer[]>([]);
  const [filteredCustomers, setFilteredCustomers] = useState<Customer[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const token = window.localStorage.getItem("token");
  const [reLogin, setReLogin] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);

  function queryCustomer() {
    setIsLoading(true);
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get("https://apibiz.oneflaretech.com/api/customer", {
        headers: headers,
      })
      .then((res) => {
        setGetCustomer(res?.data?.data);
        setFilteredCustomers(res?.data?.data); // Initialize filtered customers
        setIsLoading(false);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
        if (error.response.data.message === "jwt expired" || error.response.data.message === "jwt malformed") {
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        setIsLoading(false);
      });
  }

  useEffect(() => {
    queryCustomer();
  }, []);

  // Handle search input change
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const term = e.target.value;
    setSearchTerm(term);

    const filtered = getCustomer.filter((customer) =>
      [customer.businessName, customer.state, customer.country]
        .join(" ")
        .toLowerCase()
        .includes(term.toLowerCase())
    );
    setFilteredCustomers(filtered);
  };

  const handleCustomerClick = (customer: Customer) => {
    setSelectedCustomer(customer);
    handleCusSelect(customer);
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Customers Details</h4>
          <ImCancelCircle className="catCancel" onClick={handleCusModal} />
        </div>
        <div className="line"></div>
        {/* Search Input */}
        <div style={{ padding: "10px", textAlign: "center"}}>
          <input
            type="text"
            className="outline-none"
            placeholder="Search customers..."
            value={searchTerm}
            onChange={handleSearch}
            style={{
              width: "50%",
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />
        </div>
        {reLogin ? <ReLoginModal /> : null}
        {isLoading ? (
          <div style={{ textAlign: "center", padding: "6px", color: "secondary" }}>
            <CircularProgress />
          </div>
        ) : (
          <div className="cusmm">
            {filteredCustomers?.map((cus, inx) => {
              const customerClassName =
                cus === selectedCustomer ? "cuData selectedC" : "cuData";

              return (
                <div
                  key={cus._id}
                  className={`${customerClassName} hover:bg-gray-100`}
                  onClick={() => handleCustomerClick(cus)}
                >
                  <h2>{cus?.businessName.slice(0, 2).toUpperCase()}</h2>
                  <div>
                    <p>{cus?.businessName}</p>
                    <span>
                      {cus?.state} {cus?.country}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
        <div className="catModalBtn">
          <button
            className={`${selCus ? "catBtn2" : "opBtn"}`}
            onClick={handleCusModal}
          >
            Select
          </button>
          <button className="catBtn2" onClick={handleCusModal}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerModal;